import React from 'react';
import { Section } from './ui/Section';
import { XCircle, AlertTriangle, Clock } from 'lucide-react';
export function ProblemSection() {
  return <div className="bg-midnight-800" data-id="element-110">
      <Section className="space-y-12" data-id="element-111">
        <div className="text-center space-y-4" data-id="element-112">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white tracking-wide" data-id="element-113">
            Por qué lo que intentaste no te sostuvo
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-114">
            La higiene del sueño es buena… pero incompleta.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-115">
          <div className="space-y-6 text-lg text-white/90" data-id="element-116">
            <p data-id="element-117">
              Tu problema no es "cómo dormirte". <br data-id="element-118" />
              Tu problema es{' '}
              <span className="text-accent-red font-bold" data-id="element-119">
                qué pasa cuando despiertas
              </span>
              .
            </p>
            <p className="text-slate-300" data-id="element-120">
              En ese momento, sin darte cuenta, empiezas a entrenar el ciclo:
            </p>

            <ul className="space-y-4 mt-6" data-id="element-121">
              {['Miras el reloj y calculas horas', 'Intentas dormir a la fuerza', 'Te preocupas por el día de mañana', "Agarras el teléfono 'solo un segundo'", 'Tu cuerpo interpreta: PELIGRO'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-122">
                  <XCircle className="w-6 h-6 text-accent-red shrink-0 mt-1" data-id="element-123" />
                  <span className="text-slate-300" data-id="element-124">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="card-glass p-8 relative overflow-hidden" data-id="element-125">
            <div className="absolute top-0 right-0 p-4 opacity-5 pointer-events-none" data-id="element-126">
              <Clock size={120} data-id="element-127" />
            </div>

            <div className="flex items-center gap-3 mb-4" data-id="element-128">
              <h3 className="text-2xl font-display font-bold text-white tracking-wide" data-id="element-129">
                El error silencioso
              </h3>
              <span className="bg-accent-red/10 border border-accent-red/30 text-accent-red text-[10px] px-2 py-0.5 rounded-full uppercase tracking-wider font-bold" data-id="element-130">
                Error
              </span>
            </div>

            <p className="text-slate-300 mb-6 italic" data-id="element-131">
              "Solo voy a revisar el teléfono."
            </p>

            <div className="bg-accent-red/5 border border-accent-red/15 p-4 rounded-lg flex gap-4 items-start" data-id="element-132">
              <AlertTriangle className="w-6 h-6 text-accent-red shrink-0" data-id="element-133" />
              <p className="text-sm text-slate-300" data-id="element-134">
                El sueño no vuelve donde hay urgencia. Cuando fuerzas el sueño,
                tu cerebro entiende que estar despierta es una amenaza, y
                dispara más adrenalina.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}